// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.message[data-v-4d471c53] {\n    background-color: #ffe3e3 !important;\n    border: 1px solid #fcbdbd !important;\n    color: #921515 !important;\n    border: 1px solid rgba(37,40,43,0.1) !important;\n    border-radius: 3px !important;\n    -webkit-box-shadow: 0 1px 2px rgba(37,40,43,0.1) !important;\n            box-shadow: 0 1px 2px rgba(37,40,43,0.1) !important;\n    -webkit-transition: 0.1s !important;\n    transition: 0.1s !important;\n}\n", ""]);
// Exports
module.exports = exports;
